import { journeyAction, } from './base';

import { JourneyActionReplyLatestInboundMessage as JourneyActionReplyLatestInboundMessageBase, } from 'atlas-shared';

export const JourneyActionReplyLatestInboundMessage = journeyAction({
  ...JourneyActionReplyLatestInboundMessageBase,
  icon: 'Send',
});
